// Generated by portal/sdk/scripts/build.js.
module.exports = "/stories/milla-stories.e549839b853d.js";
